import styled from "styled-components";
import { container, grid, responsive } from "../../mixins";

export const Wrapper = styled.section`
  display: block;
  position: fixed;
  min-width: 100vw;
  background-color: var(--background-color);
  z-index: 99;
  ${responsive.tablet.standard`
    position:relative;
  `}
`;

export const Header = styled.div`
  ${container()};
  ${grid()}
  grid-template-columns: 1fr 100px 1fr;

  ${responsive.tablet.standard`
  width: var(--fluid-width);
    grid-template-columns: 1fr;
    justify-content: center;
  `}
`;
